import {
  Assessment as ReportIcon,
  PersonAddAlt as PersonAddIcon,
  AttachMoney as MoneyIcon,
  SvgIconComponent,
} from '@mui/icons-material';
import { ReactChatbotStrings } from '../locales/reactChatbot.locales';

export interface ChatbotShortcut {
  // Key in ReactChatbotStrings — the label rendered to the user.
  labelKey: keyof ReactChatbotStrings;
  // Message actually sent to the bot when the shortcut is clicked.
  // Pulled from the locale dictionary so it stays translated.
  messageKey: keyof ReactChatbotStrings;
  icon: SvgIconComponent;
}

export const CHATBOT_SHORTCUTS: ChatbotShortcut[] = [
  {
    labelKey: 'shortcutGenerateCommissionsReport',
    messageKey: 'shortcutGenerateCommissionsReport',
    icon: ReportIcon,
  },
  {
    labelKey: 'shortcutHowToCreateClient',
    messageKey: 'shortcutHowToCreateClient',
    icon: PersonAddIcon,
  },
  {
    labelKey: 'shortcutViewCommissions',
    messageKey: 'shortcutViewCommissions',
    icon: MoneyIcon,
  },
];
